import { Button, CircularProgress } from '@mui/material';
import RefreshIcon from 'assets/icons/chart_reset_zoom_move_icon.svg?react';
import ForbiddenTooltip from 'components/general/ForbiddenTooltip/ForbiddenTooltip';
import { formatTranslation } from 'intl';
import { CommonTranslationKeys } from 'intl/keys';
import { PermissionTranslationKeys } from 'shared/domain/permissions/translationKeys';
import type { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import type { ChartRefreshButtonProps } from './types';

const refreshButtonSx = {
  textTransform: 'capitalize',
  height: 'fit-content',
} as const;

export function ChartRefreshButton({
  chartId,
  isOffline,
  isRefreshing,
  onRefresh,
}: ChartRefreshButtonProps): ReactElement {
  const intl = useIntl();

  return (
    <ForbiddenTooltip
      visibleWhen={isOffline}
      reason={PermissionTranslationKeys.OFFLINE_UNAVAILABLE}
    >
      <Button
        id={chartId}
        disabled={isOffline || isRefreshing}
        data-qa='refresh-chart'
        onClick={onRefresh}
        startIcon={isRefreshing ? <CircularProgress size={20} /> : <RefreshIcon />}
        sx={refreshButtonSx}
      >
        {formatTranslation(intl, CommonTranslationKeys.refresh)}
      </Button>
    </ForbiddenTooltip>
  );
}
